// extracted by mini-css-extract-plugin
export default {"wrapper":"ActiveFiltersContainer_wrapper__M6ZdR"};